import { Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

type Prop = {
    idPengajuan: any
    handleShow4: any
    show4: any
    handleClose4: any
    isLoadingModal: any
    isFetchingPOApproved: any
    perihal: any
    setPaymentMethod: any
    setDateTo: any
    changes: any
    sektorID: any
    setSignerPositon: any
    singerposition: any
    customerAddress: any
    customerCode: any
    setKepada: any
    setPerihalTanggal: any
    setDateFrom: any
    setSignerName: any
    signername: any
    customerName: any
    setShow4: any
    getOrder: any
    numberURL: any
    paginateNumber: any
    fullPO: any
    dateFrom: any
    dateTo: any
    paymentMethod: any
    kepada: any
    perihalTanggal: any
    canUpdate: any
}

const ApprovalSIPDetailForm: React.FC<Prop> = ({
    idPengajuan,
    perihal,
    setPaymentMethod,
    setDateTo,
    changes,
    sektorID,
    setSignerPositon,
    singerposition,
    customerAddress,
    customerCode,
    setKepada,
    setPerihalTanggal,
    setDateFrom,
    setSignerName,
    signername,
    customerName,
    dateFrom,
    dateTo,
    paymentMethod,
    kepada,
    perihalTanggal,
    canUpdate,
}) => {

    const {t} = useTranslation()

  return (
    <>
      <Row>
        <Col md={6}>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>{t('order-no')}</p>
            </Col>
            <Col md={7}>
                <Form.Control
                  type='text'
                  className='me-1'
                  disabled
                  value={idPengajuan}
                  placeholder={t('order-no')}
                  size='sm'
                />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>{t('Customer Name')}</p>
            </Col>
            <Col md={7}>
              <Form.Control
                type='text'
                value={customerName}
                placeholder={t('Customer Name')}
                disabled
                size='sm'
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>
                {t('Assigner Name')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col md={7}>
              <Form.Control
                size='sm'
                id='assname'
                disabled={!canUpdate}
                value={signername}
                placeholder={t('Assigner Name')}
                onChange={(e: any) => setSignerName(e.target.value)}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>
                {t('Start-Date')}
                <span className='text-danger' hidden={sektorID != '2' ? false : true}>
                  *
                </span>
              </p>
            </Col>
            <Col md={7}>
              <Form.Control
                type='date'
                id='inputdate2'
                key={changes}
                disabled={!canUpdate}
                aria-label='Default select example'
                value={dateFrom}
                size='sm'
                onChange={(e: any) => {
                  setDateFrom(e.target.value)
                }}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>
                {t('Tanggal Pengajuan SIP')} <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col md={7}>
              <Form.Control
                type='date'
                id='inputdate'
                key={changes}
                disabled={!canUpdate}
                aria-label='Default select example'
                value={perihalTanggal}
                size='sm'
                onChange={(e: any) => {
                  setPerihalTanggal(e.target.value)
                }}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>
                {t('kepada')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col md={7}>
              <Form.Control
                size='sm'
                id='kepada'
                value={kepada}
                disabled={!canUpdate}
                placeholder={t('kepada')}
                onChange={(e: any) => setKepada(e.target.value)}
              />
            </Col>
          </Row>
        </Col>
        <Col md={6}>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>{t('Customer Number')}</p>
            </Col>
            <Col md={7}>
              <Form.Control
                type='text'
                value={customerCode}
                placeholder={t('Customer Number')}
                disabled
                size='sm'
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>{t('Address')}</p>
            </Col>
            <Col md={7}>
              <Form.Control
                as='textarea'
                value={customerAddress}
                placeholder={t('Address')}
                disabled
                style={{height: '40px'}}
                size='sm'
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>
                {t('Assigner Position')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col md={7}>
              <Form.Control
                id='asspos'
                size='sm'
                placeholder={t('Assigner Position')}
                value={singerposition}
                disabled={!canUpdate}
                onChange={(e: any) => setSignerPositon(e.target.value)}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>
                {t('End-Date')}
                <span className='text-danger' hidden={sektorID != '2' ? false : true}>
                  *
                </span>
              </p>
            </Col>
            <Col md={7}>
              <Form.Control
                type='date'
                id='inputdate3'
                key={changes}
                aria-label='Default select example'
                size='sm'
                value={dateTo}
                disabled={!canUpdate}
                onChange={(e: any) => {
                  setDateTo(e.target.value)
                  // console.log(perihalTanggal)
                }}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>{t('Metode Pembayaran')}</p>
            </Col>
            <Col md={7}>
              <Form.Control
                as='textarea'
                id='metodepembayaran'
                value={paymentMethod}
                style={{height: '40px'}}
                disabled={!canUpdate}
                placeholder={t('Metode Pembayaran')}
                onChange={(e: any) => setPaymentMethod(e.target.value)}
                size='sm'
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col md={5}>
              <p className='fs-4 mt-2'>{t('order-perihal')} </p>
            </Col>
            <Col md={7}>
              <Form.Control
                type='text'
                key={perihal}
                placeholder={t('order-perihal')}
                aria-label='Default select example'
                size='sm'
                value={
                  perihal == 'PO002' ? t('Non-penjualan') : perihal == 'PO001' ? t('penjualan') : ''
                }
                disabled
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default ApprovalSIPDetailForm
